import { useTranslation } from 'react-i18next';
import { Button, Modal } from '../../../core';
import Icon from '../../../core/components/icon-svg/icon';
import './drivelog-modal.scss';

const DriveLogModal = (props) => {
	const { t } = useTranslation('at');
	const { showModal, setShowModal, validateStep } = props;

	const confirmCallback = () => {
		validateStep(true);
	};

	const denyCallback = () => {
		validateStep(false);
	};

	const cancelCallback = () => {
		setShowModal(!showModal);
	};

	return (
		showModal && (
			<Modal type="custom">
				<button className="modal__icon" onClick={cancelCallback}>
					<Icon name="close" />
				</button>
				<div className="modal__container">
					<p className="modal__container__content">{t('modal.confirmation')}</p>
				</div>
				<div className="modal__container__button">
					<Button className="button--outline" onClick={denyCallback}>
						{t('modal.no')}
					</Button>
					<Button className="button" onClick={confirmCallback}>
						{t('modal.yes')}
					</Button>
				</div>
			</Modal>
		)
	);
};

export default DriveLogModal;
